import { useContext, useEffect, useState } from "react";
import SocketContext from "../../../../context/SocketContext";

export default function Time({ symbol_id }) {
  const socket = useContext(SocketContext);

  const [time, setTime] = useState(null);

  useEffect(() => {
    if (!symbol_id) return;

    socket.emit("giverate", symbol_id);

    const trade = (data) => {
      if (data != null && data.Timestamp !== undefined) {
        if (
          data.Timestamp &&
          typeof data.Timestamp === "string" &&
          data.Timestamp !== "0"
        ) {
          // Assuming Timestamp format "YYYY-MM-DD HH:MM:SS"
          const timePart = data.Timestamp.split(" ")[1];
          setTime(timePart || "--:--"); // Fallback in case split fails
        } else {
          setTime("--:--");
        }
      }
    };

    socket.on("trade" + symbol_id, trade);

    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, [socket, symbol_id]);

  return time;
}
